/**
 * Wohin nach erfolgreicher Anmeldung?
 *
 * `ProtectedRoute` legt den urspruenglich gewuenschten Ort als
 * `state.from` in den History-Eintrag, bevor es auf `/auth` umleitet. Ohne
 * diese Aufloesung landete jeder Nutzer stumpf auf `/`, und der einzige
 * dauerhafte Wiedereinstieg in den Report (die Report-Mail) brach genau im
 * wahrscheinlichsten Fall: Klick am naechsten Tag, Sitzung abgelaufen.
 *
 * Der Zustand kommt aus dem History-Eintrag und ist damit vom Nutzer
 * beschreibbar. Deshalb wird nur ein einzelner, seiteninterner Pfad
 * akzeptiert: alles andere ist eine Weiterleitung auf eine fremde Seite und
 * faellt auf die Startseite zurueck.
 */
export function postLoginRedirect(state: unknown): string {
  const from = (state as { from?: { pathname?: unknown; search?: unknown } } | null | undefined)?.from;

  const pathname = typeof from?.pathname === 'string' ? from.pathname : null;
  if (!pathname) return '/';

  // Genau ein fuehrender Schraegstrich. `//host` ist protokollrelativ und
  // damit extern, `https://host` ohnehin.
  if (!pathname.startsWith('/') || pathname.startsWith('//')) return '/';

  // Die Anmeldeseite selbst wuerde sofort wieder umleiten.
  if (pathname === '/auth' || pathname.startsWith('/auth/')) return '/';

  const search = typeof from?.search === 'string' ? from.search : '';
  return `${pathname}${search}`;
}
